export function popup() {
  $('.open-popup').on('click', function (e) {
    e.preventDefault();

    $(`.popup[data-popup-id=${$(this).data('popup-id')}]`).addClass('open');
  });

  $('.popup').on('click', '.close', function (e) {
    e.preventDefault();
    $(e.delegateTarget).removeClass('open');
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/popup.js